import React from 'react';

import { SpecialTime } from '../components/SpecialTime';
import { useCountdownTimer } from '../services/useCountdownTimer';
import { useSpecialTimeService } from '../services/useSpecialTimeService';

export const SpecialTimeContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const services = useSpecialTimeService();

  if (services.isHide) {
    return null;
  }

  const WrapSpecialTime = () => {
    const { countdown, is_ended } = useCountdownTimer(services.endTime);
    if (is_ended) {
      return null;
    }
    return <SpecialTime {...countdown} />;
  };

  return <WrapSpecialTime />;
};
